const common = {
  'nav.home': '首页',
  'nav.category': '分类',
  'nav.about': '关于我们',
  'nav.search': '搜索视频...',
  'nav.login': '登录',
  'nav.register': '注册',
  'nav.vip': 'VIP会员',
  'footer.brand': '黄瓜视频',
  'footer.description': '黄瓜视频是一个免费高清视频播放平台，提供海量影视内容，支持多终端在线观看。无需下载，即点即播，畅享极致流媒体体验。',
  'footer.quickLinks': '快速链接',
  'footer.categories': '热门分类',
  'footer.contact': '联系我们',
  'footer.copyright': '© 2026 黄瓜视频在线观看 版权所有',
  'footer.email': 'support@huanggua.video',
  'footer.phone': '400-888-0000',
  'footer.address': '北京市朝阳区黄瓜路88号',
  'breadcrumb.home': '首页',
  'hero.title': '黄瓜视频在线观看',
  'hero.subtitle': '海量高清视频，随时随地畅享',
  'hero.search': '搜索你想看的视频...',
  'hero.cta': '立即体验',
  'hero.stats.users': '活跃用户',
  'hero.stats.videos': '视频资源',
  'hero.stats.categories': '内容分类',
  'category.title': '视频分类',
  'category.all': '全部',
  'category.viewAll': '查看全部',
  'video.views': '次播放',
  'video.duration': '时长',
  'video.watchNow': '立即观看',
  'article.readMore': '阅读全文',
  'article.latest': '最新文章',
  'article.related': '相关文章',
  'article.author': '作者',
  'article.date': '发布日期',
  'article.tags': '标签',
  'about.title': '关于我们',
  'about.brand': '品牌介绍',
  'about.reputation': '口碑见证',
  'about.contact': '联系我们',
  'about.mission': '我们的使命',
  'about.vision': '我们的愿景',
  'about.faq': '常见问题',
  'faq.title': '常见问题解答',
  'testimonials.title': '用户口碑',
  'cta.title': '立即开启你的观影之旅',
  'cta.subtitle': '海量高清视频内容，尽在黄瓜视频',
  'cta.button': '免费注册',
  'form.name': '姓名',
  'form.email': '邮箱',
  'form.phone': '手机号',
  'form.message': '留言内容',
  'form.submit': '提交留言',
  'form.success': '提交成功！我们会尽快与您联系。',
  'form.error': '提交失败，请稍后重试。',
  'scrollTop': '回到顶部',
  'pagination.prev': '上一页',
  'pagination.next': '下一页',
};

export default common;